


































































import { computed, defineComponent, ref, useContext, useFetch } from '@nuxtjs/composition-api'
import { CmsBlock, useCart, useCartView, useContent } from '~/composables';
import CartTooltip from './CartTooltip.vue';
import CouponCode from './CouponCode.vue';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import { cartGoToCheckoutLink } from '~/helpers/trackings/24orepro/cart';

export default defineComponent({
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    components: {
        CartTooltip,
        CouponCode,
        HTMLContent
    },
    setup() {
        const { cart, loading } = useCart();
        const { totals, discount } = useCartView();

        const discounts = computed(() => cartGetters.getDiscounts(cart?.value))
        const shipping = computed(() => cartGetters.getShippingPrice(cart?.value))
        const { app } = useContext();

        const { loadBlocks } = useContent();
        const cartInfo = ref<CmsBlock | null>(null);
        useFetch(async () => {
            const cartInfoRes = await loadBlocks({ identifiers: ["solepro_cart_info"] });
            cartInfo.value = cartInfoRes[0];
        })

        const goToCheckout = ()=>{
            const redirectToCheckout = () => window.location.href = `${app.$config.paywallDomain}/checkout?quoteId=${cart.value.id}`;
            cartGoToCheckoutLink(totals.value, shipping.value, redirectToCheckout);
        }

        return {
            cart,
            totals,
            discount,
            discounts,
            scalapaySelector: '["#cart-scalapay-sum"]',
            cartInfo,
            goToCheckout
        }
    },
    methods:{
    }

})
